import RentApartmentsFlexItem from './RentApartments';
import RentCommercialsFlexItem from './RentCommercials';
import RentDailyApartmentsFlexItem from './RentDailyApartments';
import SaleApartmentsFlexItem from './SaleApartments';
import SaleCommercialsFlexItem from './SaleCommercials';
import SaleGaragesFlexItem from './SaleGarages';
import SaleLandsFlexItem from './SaleLands';

module.exports = {
  RentApartmentsFlexItem,
  RentCommercialsFlexItem,
  RentDailyApartmentsFlexItem,
  SaleApartmentsFlexItem,
  SaleCommercialsFlexItem,
  SaleGaragesFlexItem,
  SaleLandsFlexItem
};



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/index.js